import React from 'react';
import Icon from '../../../components/AppIcon';

const SystemHealthPanel = () => {
  const systemMetrics = [
    {
      name: 'Server Status',
      status: 'operational',
      value: '99.9%',
      icon: 'Server',
      description: 'Uptime'
    },
    {
      name: 'Database Performance',
      status: 'operational',
      value: '42ms',
      icon: 'Database',
      description: 'Avg. query time'
    },
    {
      name: 'API Response Time',
      status: 'operational',
      value: '128ms',
      icon: 'Zap',
      description: 'Avg. response'
    },
    {
      name: 'Storage Usage',
      status: 'warning',
      value: '78%',
      icon: 'HardDrive',
      description: 'Capacity used'
    }
  ];

  const getStatusColor = (status) => {
    if (status === 'operational') return 'emerald';
    if (status === 'warning') return 'amber';
    return 'red';
  };

  const getStatusIcon = (status) => {
    if (status === 'operational') return 'CheckCircle';
    if (status === 'warning') return 'AlertCircle';
    return 'XCircle';
  };

  const colorClasses = {
    emerald: 'text-emerald-600 bg-emerald-500/10',
    amber: 'text-amber-600 bg-amber-500/10',
    red: 'text-red-600 bg-red-500/10'
  };

  const iconColors = {
    emerald: '#10B981',
    amber: '#F59E0B',
    red: '#EF4444'
  };

  return (
    <div className="bg-white border border-slate-200 rounded-xl p-6 elevation-sm">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-bold text-slate-900 font-heading">
            System Health
          </h3>
          <p className="text-sm text-slate-600 font-body mt-1">
            Real-time monitoring
          </p>
        </div>
        <div className="flex items-center gap-2 px-3 py-1.5 bg-emerald-50 rounded-lg">
          <div className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" />
          <span className="text-xs font-semibold text-emerald-600">Live</span>
        </div>
      </div>

      <div className="space-y-4">
        {systemMetrics?.map((metric, index) => {
          const statusColor = getStatusColor(metric?.status);
          const statusIcon = getStatusIcon(metric?.status);

          return (
            <div
              key={index}
              className="p-4 rounded-lg border border-slate-200 hover:border-slate-300 transition-colors"
            >
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-lg bg-slate-100 flex items-center justify-center">
                    <Icon name={metric?.icon} size={16} color="#64748B" />
                  </div>
                  <span className="text-sm font-medium text-slate-900">
                    {metric?.name}
                  </span>
                </div>
                <div className={`w-6 h-6 rounded-full flex items-center justify-center ${colorClasses?.[statusColor]}`}>
                  <Icon name={statusIcon} size={14} color={iconColors?.[statusColor]} />
                </div>
              </div>
              <div className="flex items-baseline justify-between">
                <span className="text-2xl font-bold text-slate-900">
                  {metric?.value}
                </span>
                <span className="text-xs text-slate-500">
                  {metric?.description}
                </span>
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-6 pt-6 border-t border-slate-200">
        <button className="w-full flex items-center justify-center gap-2 px-4 py-2 bg-slate-100 hover:bg-slate-200 rounded-lg transition-colors">
          <Icon name="Activity" size={16} color="#64748B" />
          <span className="text-sm font-medium text-slate-700">View Detailed Metrics</span>
        </button>
      </div>
    </div>
  );
};

export default SystemHealthPanel;